import theme from '@/styles/theme';

import { ClaimBreakdownCategory, ClaimBreakdownPaymentCategory } from './EmployerServiceCategories.types';

const cardTypeColors = theme.colors.cardTypes as Record<string, string>;

export const CATEGORY_COLORS: Record<ClaimBreakdownCategory, string> = {
  [ClaimBreakdownCategory.MEDICAL]: cardTypeColors.MEDICAL,
  [ClaimBreakdownCategory.DENTAL]: cardTypeColors.DENTAL,
  [ClaimBreakdownCategory.VISION]: cardTypeColors.VISION,
  [ClaimBreakdownCategory.PHARMACY]: cardTypeColors.RX,
  [ClaimBreakdownCategory.DEPENDENT_CARE]: cardTypeColors.DCAP,
  [ClaimBreakdownCategory.PARKING]: cardTypeColors.PARKING,
  [ClaimBreakdownCategory.TRANSIT]: cardTypeColors.TRANSIT,
  [ClaimBreakdownCategory.ADOPTION]: cardTypeColors.ADOPTION,
  [ClaimBreakdownCategory.PREMIUM]: cardTypeColors.HRA,
  [ClaimBreakdownCategory.LIFE_STYLE]: cardTypeColors.LIFESTYLE,
  [ClaimBreakdownCategory.WELLNESS]: cardTypeColors.HSA,
  [ClaimBreakdownCategory.TRAVEL]: cardTypeColors.TRAVEL,
  [ClaimBreakdownCategory.PLAN_SPECIFIC]: cardTypeColors.SPECIALTY,
};

export const PAYMENT_METHOD_COLORS: Record<ClaimBreakdownPaymentCategory, string> = {
  [ClaimBreakdownPaymentCategory.REIMBURSEMENT]: cardTypeColors.DENTAL,
  [ClaimBreakdownPaymentCategory.BILL_PAY]: cardTypeColors.MEDICAL,
  [ClaimBreakdownPaymentCategory.CARD]: cardTypeColors.HCFSA,
  [ClaimBreakdownPaymentCategory.HEALTH_PLAN_REIMBURSEMENT]: cardTypeColors.RX,
  [ClaimBreakdownPaymentCategory.HEALTH_PLAN_BILL_PAY]: cardTypeColors.DCAP,
  [ClaimBreakdownPaymentCategory.OTHER]: theme.colors.iconDisabled,
};

export const DEFAULT_VISIBLE_CATEGORIES = 4;

export const CATEGORY_LABELS: Record<ClaimBreakdownCategory, string> = {
  [ClaimBreakdownCategory.MEDICAL]: 'Medical',
  [ClaimBreakdownCategory.DENTAL]: 'Dental',
  [ClaimBreakdownCategory.VISION]: 'Vision',
  [ClaimBreakdownCategory.PHARMACY]: 'Pharmacy',
  [ClaimBreakdownCategory.DEPENDENT_CARE]: 'Dependent care',
  [ClaimBreakdownCategory.PARKING]: 'Parking',
  [ClaimBreakdownCategory.TRANSIT]: 'Transit',
  [ClaimBreakdownCategory.ADOPTION]: 'Adoption',
  [ClaimBreakdownCategory.PREMIUM]: 'Premium',
  [ClaimBreakdownCategory.LIFE_STYLE]: 'Lifestyle',
  [ClaimBreakdownCategory.WELLNESS]: 'Wellness',
  [ClaimBreakdownCategory.TRAVEL]: 'Travel',
  [ClaimBreakdownCategory.PLAN_SPECIFIC]: 'Plan specific',
};

/**
 * Human-readable labels for payment method types.
 */
export const PAYMENT_METHOD_LABELS: Record<ClaimBreakdownPaymentCategory, string> = {
  [ClaimBreakdownPaymentCategory.REIMBURSEMENT]: 'Reimbursement',
  [ClaimBreakdownPaymentCategory.BILL_PAY]: 'Bill Pay',
  [ClaimBreakdownPaymentCategory.CARD]: 'Card',
  [ClaimBreakdownPaymentCategory.HEALTH_PLAN_REIMBURSEMENT]: 'Health Plan - Reimbursement',
  [ClaimBreakdownPaymentCategory.HEALTH_PLAN_BILL_PAY]: 'Health Plan - Bill Pay',
  [ClaimBreakdownPaymentCategory.OTHER]: 'Other',
};
